<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path
    d="M11.9195 2H3.5C2.94772 2 2.5 2.44772 2.5 3V16.5C2.5 17.0523 2.94772 17.5 3.5 17.5H17.5C18.0523 17.5 18.5 17.0523 18.5 16.5V8.60466"
    stroke="#002D72"
    stroke-width="1.2"
    stroke-linecap="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.1581 13.5677C10.0085 13.5677 9.86458 13.5082 9.75749 13.4017L5.66615 9.3092C5.44462 9.08823 5.44462 8.72958 5.66615 8.50804C5.88712 8.28707 6.24577 8.28707 6.46731 8.50804L10.0957 12.137L17.479 2.2274C17.6659 1.97754 18.0206 1.92541 18.2722 2.11182C18.5226 2.29879 18.5747 2.65404 18.3878 2.90504L10.6125 13.3393C10.5139 13.4714 10.3637 13.5541 10.1994 13.566C10.1853 13.5671 10.1722 13.5677 10.1581 13.5677Z"
    fill="#002D72"
  />
</svg>
